import AboutSec2 from "../../../About/AboutSec2/AboutSec2";
import HomeAboutSec from "../../../Home/HomeAboutSec";
import HomeCtaBanner from "../../../Home/HomeCtaBanner/HomeCtaBanner";
import IndustriesSec2 from "../../IndustiresSec2/IndustriesSec2";
import IndustriesSec3 from "../../IndustriesSec3/IndustriesSec3";
import SEO from "../../../../components/SEO";

export default function WasteManagement({ currentLanguage = "en" }) {
  const pageTitles = {
    en: "Waste Management",
    fr: "Gestion des déchets",
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;

  return (
    <>
      <SEO title={pageTitle} />
      <HomeAboutSec currentLanguage={currentLanguage} />
      <IndustriesSec3 currentLanguage={currentLanguage} />
      <AboutSec2 currentLanguage={currentLanguage} />
      <IndustriesSec2 currentLanguage={currentLanguage} />
      <HomeCtaBanner currentLanguage={currentLanguage} />
    </>
  );
}

